import * as api from '../../api';
import { takeEvery } from '../../listenerMiddleware';
import * as googleBulkActions from './actions';
import { runTask } from '@myua/api';
import { createHash, GoogleBulkMode } from './model';
import { message } from '@myua/kit';
import { getInProgress } from './selectors';
import { z } from 'zod';

export const googleBulkListeners = () => {
  watchLinkRequested();
};

function watchLinkRequested() {
  takeEvery(googleBulkActions.linkRequested, async ({ payload }, { getState, dispatch }) => {
    let request;
    const hash = createHash(payload);

    if (payload.mode === GoogleBulkMode.assets) {
      request = api.createGoogleBulkLink(payload.assetIds, payload.sharingId);
    } else if (payload.mode === GoogleBulkMode.pack) {
      request = api.createGoogleBulkLinkPack();
    } else if (payload.mode === GoogleBulkMode.sharingAll) {
      if (!payload.sharingId) {
        return;
      }
      request = api.createGoogleBulkLinkSharingAll(payload.sharingId);
    } else {
      return;
    }

    const inProgress = getInProgress(getState());
    if (inProgress[hash]) {
      return;
    }

    dispatch(googleBulkActions.setInProgress({ hash, inProgress: true }));

    const result = await request;

    if (!result.success) {
      dispatch(googleBulkActions.setInProgress({ hash, inProgress: false }));
      const parsed = z.object({ detail: z.string() }).safeParse(result.data.response);
      void message.error(
        parsed.success ? parsed.data.detail : 'Failed to run task for creating Google Drive link',
      );
      return;
    }

    const taskId = result.data.response.task_id;
    const taskResult = await runTask<string>(taskId, 2000, undefined, ({ status, data }) => {
      if (status === 'STARTED') {
        const parsed = z.object({ progress: z.number() }).safeParse(data);
        if (parsed.success) {
          dispatch(googleBulkActions.setProgressValue({ hash, value: parsed.data.progress }));
        }
      }
    });

    dispatch(googleBulkActions.setInProgress({ hash, inProgress: false }));

    if (taskResult.success) {
      dispatch(googleBulkActions.linkCreated({ hash, link: taskResult.data }));
    } else {
      void message.error({ content: taskResult.error, duration: 5 });
    }
  });
}
